'use client';
import { useTranslation } from 'react-i18next';
import SafeLink from '../SafeLink';
// -------------- icons -------------------- //
import EmailSvg from '@/components/svg/email';
import SocialFacebook from '@/components/svg/facebook';
import WhatsAppSvg from '@/components/svg/whatsApp';
import SocialX from '@/components/svg/x';
// -------------- styles -------------------- //
import { useEffect, useState } from 'react';
import styles from './shareToNew.module.scss';

interface ShareToNewPropTypes {
  title: string;
  currencySymbol: string;
  mainPrice: string;
}

const ShareToNew = ({ title, currencySymbol, mainPrice }: ShareToNewPropTypes) => {
  const shareTitle = `${title} | ${currencySymbol}${mainPrice}`;
  const { t } = useTranslation();
  const [locationHref, setLocationHref] = useState('');
  const href = encodeURIComponent(locationHref);
  const shareText = encodeURIComponent(shareTitle || '');
  const shareTextWithLink = encodeURIComponent(`${shareTitle} ${locationHref}`);

  useEffect(() => {
    setLocationHref(window.location.href);
  }, []);

  const SocialPlatforms = [
    {
      link: `https://api.whatsapp.com/send?text=${shareTextWithLink}`,
      svg: <WhatsAppSvg className={styles.myicon} />,
    },
    {
      link: `https://www.facebook.com/sharer/sharer.php?u=${href}`,
      svg: <SocialFacebook className={styles.myicon} />,
    },
    {
      link: `mailto:?subject=Joybuy&body=${shareTextWithLink}`,
      svg: <EmailSvg className={styles.myicon} />,
    },
    {
      link: `https://twitter.com/intent/tweet?button_hashtag=Joybuy&ref_src=twsrc%5Etfw&url=${href}&text=${shareText}`,
      svg: <SocialX className={styles.myicon} />,
    },
  ];
  return (
    <div className={styles.container}>
      <span>{t('dp.shareTitle')}</span>

      {SocialPlatforms.map(({ link, svg }: any, index: number) => {
        return (
          <SafeLink key={index} href={link} rel='nofollow noopener noreferrer' target='_blank'>
            {svg}
          </SafeLink>
        );
      })}
    </div>
  );
};

export default ShareToNew;
